import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllmanifiestos() {
    

  //console.log(valor);
    const ManifiestosDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Manifiestos/Manifiestos/Manifiestos/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      ManifiestosDB.push(doc.data());
    });
    return ManifiestosDB;
    

}
